/* eslint-disable @typescript-eslint/no-empty-function */
import {EventEmitter, Injectable} from '@angular/core'

@Injectable({providedIn: 'root'})
export class SwipeServiceService {
  swipeObserver: EventEmitter<number> = new EventEmitter()

  constructor() {
  }

  closeAll(id: number | undefined) {
    this.swipeObserver.emit(id)
  }
}
